module.exports = __webpack_public_path__ + "img/upgrade.5639e739.png";